function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    html {\n        font-family: system-ui,\n         -apple-system,\n         \"Segoe UI\",\n         \"Roboto\",\n         \"Ubuntu\",\n         \"Cantarell\",\n         \"Noto Sans\",\n         sans-serif,\n         \"Apple Color Emoji\",\n         \"Segoe UI Emoji\",\n         \"Segoe UI Symbol\",\n         \"Noto Color Emoji\";\n    }\n\n    code,\n    kbd,\n    samp,\n    pre {\n        font-family: \"Menlo\",\n         \"Consolas\",\n         \"Roboto Mono\",\n         \"Ubuntu Monospace\",\n         \"Noto Mono\",\n         \"Oxygen Mono\",\n         \"Liberation Mono\",\n         monospace,\n         \"Apple Color Emoji\",\n         \"Segoe UI Emoji\",\n         \"Segoe UI Symbol\",\n         \"Noto Color Emoji\";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from '@emotion/react';
export var typography = css(_templateObject());